export enum AssetStatus {
  OPERATIONAL = 'Operational',
  OUT_OF_SERVICE = 'Out of Service',
}
